<template>
	<contentBox v-if="!loadError" v-bind:loading="loading">
		<contentTitle v-if="communityPlan" label="EDIT COMMUNITY PLAN" v-bind:close="routeClose">
			<h2 class="text-white font-weight-light pb-2">{{communityPlan.name}}</h2>
		</contentTitle>
		<contentBody v-if="communityPlan" v-bind:locked="token === null || !isAdmin">
			<div class="p-3">
				<div class="lock-block" v-if="token === null || !isAdmin">
					<div class="row mx-0 hover-dk" v-on:click="routeLogin">
						<div class="col-2 text-center my-auto">
							<i class="material-icons text-light mr-3 md-36">account_box</i>
						</div>
						<div class="py-3 col-10 pl-0 pr-3 py-3">
							<h5 class="mb-0 text-white">Sign in to edit</h5>
							<h5 class="mb-0 font-weight-light text-light">You do not have permission to edit this record</h5>
						</div>
					</div>
				</div>
				<div v-if="token !== null && isAdmin" class="category-body">
					<div v-if="mode === 'detailsEdit'" class="section section-bold">
						<div class="section-title">
							Edit Details
							<span v-on:click="setMode(null)" class="category-title-btn"><i class="material-icons md-14">close</i></span>
						</div>
						<div class="section-body">
							<div class="category">
								<div class="category-title">DESCRIPTION</div>
								<div class="property-row">
									<textarea class="form-control" rows="10" v-model="rec.description"></textarea>
								</div>
							</div>
						</div>
						<div class="section-footer">
							<button v-on:click="saveDetails" class="btn btn-sm btn-primary float-right">Save</button>
						</div>
					</div>
					<div v-else class="section">
						<div class="section-title">
							Details
							<span v-on:click="setMode('detailsEdit')" class="category-title-btn"><i class="material-icons md-14">edit</i></span>
						</div>
						<div class="section-body">
							<div class="category">
								<div class="category-title">DESCRIPTION</div>
								<div class="property-row">
									<div v-if="description" class="text-description">{{description}}</div>
									<span v-else class="undef">
										-
									</span>
								</div>

							</div>
						</div>
					</div>

					<div v-if="communityPlan.references" v-for="(ref, idx) in communityPlan.references">
						<div v-if="mode === 'referenceDelete' && referenceDeleteInd === idx" class="section section-bold">
							<div class="section-title">
								Delete Reference {{idx+1}}
								<span v-on:click="setMode(null)" class="category-title-btn"><i class="material-icons md-14">close</i></span>
							</div>
							<div class="section-body">
								<div class="property-row">
									Are you sure you want to delete this reference?
								</div>
							</div>
							<div class="section-footer">
								<button v-on:click="referenceDeleteSubmit" class="btn btn-sm btn-danger float-right">Delete</button>
							</div>
						</div>
						<referenceForm 
							v-else-if="mode === 'referenceEdit' && referenceEditInd === idx" 
							@close="setMode(null)" 
							@submit="referenceSave"
							:reference="communityPlan.references[idx]" 
							submitLabel="Save" 
							:title="`Edit Reference ${idx+1}`"/>
						<div v-else class="section">
							<div class="section-title">
								Reference {{idx+1}}
								<span v-on:click="referenceDelete(idx)" class="category-title-btn"><i class="material-icons md-14">delete</i></span>
								<span v-on:click="referenceEdit(idx)" class="category-title-btn"><i class="material-icons md-14">edit</i></span>
							</div>
							<div class="section-body">
								<div class="category">
									<div class="category-title">DESCRIPTION</div>
									<div v-if="ref.description" class="property-row">
										{{ref.description}}
									</div>
									<span v-else class="undef">
										-
									</span>
								</div>
								<div class="category">
									<div class="category-title">URL</div>
									<div v-if="ref.url" class="property-row word-wrap-break">
										{{ref.url}}
									</div>
									<span v-else class="undef">
										-
									</span>
								</div>
							</div>
						</div>

					</div>
					<referenceForm 
						v-if="mode === 'referenceAdd'" 
						@close="setMode(null)" 
						@submit="referenceAdd"
						submitLabel="Add" 
						title="Add Reference"/>
					<div v-else class="mb-3">
						<button v-on:click="setMode('referenceAdd')" class="btn btn-dark btn-sm">Add Reference</button>
					</div>
				</div>
			</div>
		</contentBody>
	</contentBox>

</template>

<script>

import contentBox from '../content';
import contentActions from '../content/content-actions';
import contentBody from '../content/content-body';
import contentTitle from '../content/content-title';
import referenceForm from './reference-form';

export default {
	name: 'community-plan-edit',

	components:{
		contentBox,
		contentActions,
		contentBody,
		contentTitle,
		referenceForm,
	},

	destroyed: function(){
		this.$store.dispatch('COMMUNITY_PLAN_HIGHLIGHT_CLEAR',{});
	},

	computed: {
		isAdmin: function(){
			return this.$store.state.agent.rec && this.$store.state.agent.rec.role.name && this.$store.state.agent.rec.role.name === 'admin';
		},
		token: function(){
			return this.$store.state.agent.token;
		},
		communityPlan: function() {
			return this.$store.state.communityPlan.rec;
		},
		mapZoom: function(){
			return this.$store.state.map.params.zoom;
		},
		mapLoaded:function(){
			return this.$store.state.map.loaded;
		},
		mapBounds:function(){
			return this.$store.state.map.bounds;
		},
		description:function(){
			return this.communityPlan.description;
		},
		zoomToDone:function(){
			return this.$store.state.map.fitBoundsDone;
		}
	},
	created: function(){
		this.getRec();
	},
	data: function(){
		return {
			descriptionExpanded:false,
			loadError:null,
			loading:true,
			mode:null,
			rec:null,
			recLoaded:false,
			shareShown:false,
		}
	},
	methods: {
		checkInside:function(){
			const bbox = this.communityPlan.bounds.bbox;
			const bounds = this.mapBounds;

			if (this.mapZoom >= 13 || this.mapZoom <= 10) return false;
			if (bbox[1] > bounds._ne.lat || bbox[3] < bounds._sw.lat || 
				bbox[0] > bounds._ne.lng || bbox[2] < bounds._sw.lng){
				return false;
			}

			return true;
		},
		checkReady:function(){ //called to check if and resolve when all resources have been loaded
			if (!this.communityPlan || !this.recLoaded || !this.mapLoaded) return;
			this.ready();
		},
		getRec: function(){
			this.recLoaded = false;
			this.loadError = null;
			this.$store.dispatch('COMMUNITY_PLAN_GET', {
				id: this.id
			}).catch((error)=>{
				this.loadError = error;
			});			
		},
		highlight:function(){
			this.$store.dispatch('COMMUNITY_PLAN_HIGHLIGHT',{});
		},
		ready:function(){
			if (!this.checkInside()) this.zoomTo();
			else this.highlight();
			this.updateTitleTag();
		},
		referenceAdd:async function(reference){
			this.loading = true;
			await this.$store.dispatch('COMMUNITY_PLAN_REFERENCE_ADD', {
				id:this.$route.params.id, 
				reference:reference
			});
			this.loading = false;
			this.setMode(null);
		},
		referenceDelete:function(ind){
			this.setMode('referenceDelete');
			this.referenceDeleteInd = ind;
		},
		referenceSave:async function(reference){
			this.loading = true;
			const referenceId = this.communityPlan.references[this.referenceEditInd].id;
			await this.$store.dispatch('COMMUNITY_PLAN_REFERENCE_SAVE', {
				id:this.$route.params.id, 
				referenceId:referenceId,
				reference:reference
			});
			this.loading = false;
			this.setMode(null);
		},
		referenceDeleteSubmit:async function(){
			this.loading = true;
			const referenceId = this.communityPlan.references[this.referenceDeleteInd].id;
			await this.$store.dispatch('COMMUNITY_PLAN_REFERENCE_DELETE', {
				id:this.$route.params.id, 
				referenceId:referenceId
			});
			this.loading = false;
			this.setMode(null);
		},
		referenceEdit:function(ind){
			this.setMode('referenceEdit');
			this.referenceEditInd = ind;
		},
		routeClose:function(){
			this.$router.push({
				name: 'community-plans', 
				params:{id:this.$route.params.id}
			});
		},
		routeLogin:function(){
			this.$router.push({
				name: 'auth', 
				params:{}
			});
		},
		updateTitleTag:function(){
			document.title = this.communityPlan.name+' Edit - Scoutred Maps';
		},
		saveDetails:async function(){
			this.loading = true;
			await this.$store.dispatch('COMMUNITY_PLAN_SAVE', {
				id:this.$route.params.id, 
				rec:this.rec
			});
			this.loading = false;
			this.setMode(null);
		},
		setMode:function(mode){
			this.mode = mode;
		},
		zoomTo:function(){
			this.$store.dispatch('COMMUNITY_PLAN_ZOOM_TO',{});
		},
	},
	watch: {
		id: function(newId, oldId){
			if (newId === oldId) return
			this.getRec();
		},
		communityPlan:function(toRec, fromRec){
			if (this.communityPlan){
				this.rec = JSON.parse(JSON.stringify(this.communityPlan))
				this.loading = false;
			}
			this.checkReady();
		},
		mapLoaded:function(){
			this.checkReady();
		},
		zoomToDone:function(){
			this.highlight();
		}
	},
}

</script>



// WEBPACK FOOTER //
// src/components/community-plan/community-plan-edit.vue